import React, { Component, PropsWithChildren } from 'react';

export interface IDialogFooterButtonProps {
    href?: string;
    target?: string;
    onClick?: () => void;
    className?: string;
}

export default class DialogFooterButton extends Component<PropsWithChildren<IDialogFooterButtonProps>> {
    constructor(props: IDialogFooterButtonProps) {
        super(props);
        this.state = {};
        this.onClick = this.onClick.bind(this);
    }

    public onClick() {
        const onClick = this.props.onClick;
        if (onClick) {
            onClick();
        }
    }

    public render() {
        const props = this.props;
        return (
            <div className="dialog-option">
                <a
                    href={props.href || 'javascript:;'}
                    target={props.target || ''}
                    className={`btn ${props.className || ''}`}
                    onClick={() => this.onClick()}
                >
                    {props.children}
                </a>
            </div>
        );
    }
}
